<template lang="html">
  <v-toolbar dark color="blue darken-4">
    <v-flex xs12 sm1>
      <a href="/home">
        <v-img
          :src="require('@/assets/logo.png')"
          :lazy-src="require('@/assets/logo.png')"
          contain
          aspect-ratio="1"
          height="45">
        </v-img>
      </a>
    </v-flex>
    <v-toolbar-title class="white--text">Naics Furnishing Co., Ltd. System</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn flat :to="{ name: 'homePage'}">หน้าบ้าน</v-btn>
      <!-- <v-btn flat :to="{ name: 'homePage'}" v-if="['logIn'].indexOf($route.name) > -1">หน้าบ้าน</v-btn> -->

      <!-- <v-dialog
        v-model="dialog"
        max-width="350"
      >
        <v-card>
          <v-card-title class="headline">คุณต้องการที่จะไปหน้าบ้าน?</v-card-title>
          <v-card-text>
            <v-alert
              :value="true"
              color="error"
              icon="new_releases"
            >
              หากคุณยืนยันระบบจะทำการออกจากระบบอัตโนมัติให้
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="homePageConfirm"
            >
              ยืนยัน
            </v-btn>
            <v-btn
              color="red darken-1"
              flat="flat"
              @click="dialog = false"
            >
              ยกเลิก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <v-tooltip bottom>
        <v-btn flat :to="{ name: 'listProductIntroPage'}">ภาพพื้นหลัง</v-btn>
      <span>กรุณา Log In</span>
    </v-tooltip>
      <v-btn flat :to="{ name: 'listProductIntroPage'}" v-if="['addProduct', 'listProductPage', 'listProductIntroPage'].indexOf($route.name) > -1">ภาพพื้นหลัง</v-btn>
      <v-btn flat :to="{ name: 'listProductPage'}" v-if="['addProduct', 'listProductPage', 'listProductIntroPage'].indexOf($route.name) > -1">สินค้า</v-btn>
      <v-btn flat @click="dialogLogOut = true" v-if="['addProduct', 'listProductPage', 'listProductIntroPage'].indexOf($route.name) > -1">ออกจากระบบ</v-btn>
      <v-dialog
        v-model="dialogLogOut"
        max-width="350"
      >
        <v-card>
          <v-card-title class="headline">คุณต้องการที่จะออกจากระบบ?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="logOut"
            >
              ยืนยัน
            </v-btn>
            <v-btn
              color="red darken-1"
              flat="flat"
              @click="dialogLogOut = false"
            >
              ยกเลิก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import firebase from 'firebase'
export default {
  data () {
    return {
      dialog: false,
      dialogLogOut: false
    }
  },
  methods: {
    logOut: function () {
      const self = this
      firebase.auth().signOut().then(function () {
        self.$router.push('/log-in')
        self.dialogLogOut = false
      })
    },
    homePageConfirm () {
      this.$router.push('/home')
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/extra/headerBackend.vue